export const frontmatter = {
    "draft": false,
    "title": "Flujos de trabajo",
    "sidebar_group": "referencia",
    "sidebar_label": "Flujos de trabajo",
    "sidebar_order": 1
}

export const toc = []